module.exports = __webpack_public_path__ + "static/media/healthdirect.a37d8d46.svg";